import TasksSection, { renderHeader } from "@/components/dashboard/tasks_section";
import { DashboardSuspense } from "../dashboard_suspense";

const Tasks = () => {
  return (
    <DashboardSuspense className="tasks-section p-6" renderHeader={renderHeader}>
      <TasksSection />
    </DashboardSuspense>
  );
};

export default Tasks;
